<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="DOB Select"
    seFeDataSubtitle="A date of birth selector"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component for date of birth inputs</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-dob-select-example></se-po-dob-select-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Over 13 Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-age-check-dob-select-example></se-po-age-check-dob-select-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
